module.exports = __webpack_public_path__ + "static/media/fix_hublot.eb10e135.png";